import { InputAdornment, InputBase, InputBaseProps, Stack } from '@mui/material';
import { useField } from 'formik';
import { NumberFormatValues, NumericFormat } from 'react-number-format';

interface PercentageInputProps extends InputBaseProps {
    label?: string;
    currency?: string;
    showEndAdornment?: boolean;
}
export const PercentageInput = ({
    label,
    placeholder,
    name,
    disabled,
    showEndAdornment = true,
    type = 'text',
    ...props
}: PercentageInputProps) => {
    const [field, meta, { setValue }] = useField<number>({ name, type });

    const MAX_LIMIT = 100.0;

    const handleOnValueChange = (values: NumberFormatValues) => {
        if (
            Number.parseFloat(values.value) &&
            Number.parseFloat(values.value) <= MAX_LIMIT &&
            Number.parseFloat(values.value) >= 0
        ) {
            setValue(values.floatValue);
        } else {
            setValue(0.0);
        }
    };

    return (
        <Stack sx={{ position: 'relative', width: '100%' }}>
            {label && <label className="mb-5 font-bold">{label}</label>}
            <NumericFormat
                {...field}
                {...props}
                defaultValue={99.99}
                value={field.value}
                allowNegative={false}
                decimalScale={2}
                fixedDecimalScale
                onValueChange={handleOnValueChange}
                customInput={InputBase}
                placeholder={placeholder}
                autoComplete="off"
                className={`form-input ${meta.touched && meta.error ? 'input-error' : ''}`}
                disabled={disabled}
                style={{
                    height: '100%',
                }}
                endAdornment={
                    showEndAdornment ? <InputAdornment position="start">%</InputAdornment> : null
                }
            />
        </Stack>
    );
};

export { InputBase };
